import {useMemo} from 'react';

// material-ui
import {Box, useMediaQuery, ListItemButton} from '@mui/material';

// project import
import Profile from './profile';
import Localization from './localization';
import Notification from './notification';
import {MenuOrientation} from "../../../../config";
import DrawerHeader from "../../drawer/drawerHeader";
import useConfig from "../../../../hooks/useConfig";
import useUserData from "../../../../../../hooks/user/useUserData";
import PermissionHOC from "../../../../../../modules/permission/components/permissionHOC/permissionHOC";
import Navigation from '../../drawer/drawerContent/navigation';
import useUserAction from "../../../../../../../src/hooks/user/useUserAction";
import { NAVIGATION } from "../../../../../../../src/locales/components/namespaces";
import { useTranslation } from "react-i18next";
import CircularCountdown from "./circularCountdown"
import LogoHeadIcon from "../../../../../../assets/images/icons/menuIcons/logoHeadIcon"
import { ROUTE_PAGE_HOME } from "../../../../../../routers/routes";
import { getRouteUrl } from "../../../../../../../src/helpers/getRouteUrl";
// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
    const {i18n, menuOrientation} = useConfig();
    const {isLoggedIn} = useUserData()
    const downMD = useMediaQuery((theme) => theme.breakpoints.down('md'));
    const { userLogout } = useUserAction()
    const { t } = useTranslation(NAVIGATION)
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const localization = useMemo(() => <Localization/>, []);

    return (
        <>
            { !downMD &&
                <>
                    <ListItemButton to={ getRouteUrl(ROUTE_PAGE_HOME) } sx={{paddingLeft:'0 !important','&:hover':{backgroundColor:'transparent'},  flexGrow: 'initial !important' }}>
                        <LogoHeadIcon />
                    </ListItemButton>
                    <Navigation />
                </>
            }

   
            <Profile/>

            <Box className="flex-center-right" sx={{margin: {xs: 'auto 0 0 auto', sm: 'auto 0 0 auto', md: '0 0 0 28px'} , '& .MuiBox-root': { margin: '0 !important'}}}>
                {isLoggedIn &&
                    <PermissionHOC requiredPermissions={['view_notifications_btn']}>
                        <Notification/>
                    </PermissionHOC>
                }

                {localization}

                <CircularCountdown onComplete={()=>{
                    userLogout()
                }}/>
            </Box>
       
        </>
    );
};

export default HeaderContent;
